up.modal.config.maxWidth = 800;
